window.BladeTooltip = {
    data(options) {
        return {
            init() {
                const template = this.$refs.contents.innerHTML;

                tippy(this.$refs.trigger, {
                    content: template,
                    theme: this.theme,
                    allowHTML: true,
                    interactive: true,
                    placement: this.placement,
                    popperOptions: {
                        strategy: "fixed",
                        modifiers: [
                            {
                                name: "flip",
                                options: {
                                    fallbackPlacements: [
                                        "top",
                                        "left",
                                        "bottom",
                                        "right",
                                    ],
                                },
                            },
                            {
                                name: "preventOverflow",
                                options: {
                                    altAxis: true,
                                    tether: false,
                                },
                            },
                        ],
                    },
                });
            },
            theme: "light",
            placement: "bottom",
            ...options,
        };
    },
};
